import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseApiTemplateService, Core2Config } from '../shared';
import { RateCardContainerModel } from '../../../../../models/aggregates/pgw/ratecard.model';

@Injectable({
  providedIn: 'root',
})
export class RateCardLineService extends BaseApiTemplateService<RateCardContainerModel> {

  constructor(http: HttpClient) {
    super();

    this.httpClient = http;
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.PGW_PREFIX + 'merchant/rate-lines';
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.PGW_PREFIX + 'merchant/rate-lines';
  }
}
